<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width=550 content-class="round-2xl" scrollable)
  v-card
    v-card-title.px-4
      v-spacer
      .text-xl.font-bold {{ $t('edit_item', { item: $t('billing_info').toLowerCase() }) }}
      v-spacer
      v-btn(icon color="neutral700" @click="closeDialog")
        v-icon mdi-close
    v-divider
    v-card-text
      v-form(ref="form")
        div.pa-4
          div.text-sm.font-semibold.neutral500--text.mt-4.mb-2 Select patient name to prefill the billing information below
          patient-dropdown(v-model="searchPatient" :fields="['address', 'relationships', 'panels']" :expandFields="['relationships.relationship']")
          v-divider.my-4
          div.text-sm.font-semibold.neutral500--text {{ $t('name') }}
          v-text-field.text-sm.mt-2.round-xl(v-model="billingInfo.name" :placeholder="$t('name')" outlined dense height="48" hide-details="auto" :rules="rules.not_empty")
          div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('phone') }}
          phone-input.mt-2(v-model="billingInfo.phone" :key="phoneKey")
          div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('id_info') }}
          v-text-field.text-sm.mt-2.round-xl(v-model="billingInfo.ic" :placeholder="$t('id_info')" outlined dense height="48" hide-details="auto")
          .address
            div.text-sm.font-semibold.neutral500--text.mt-4 {{$t('address_1.label')}}
            v-text-field.text-sm.mt-2.round-xl(v-model="billingInfo.address.address_1" :placeholder="$t('address_1.placeholder')" outlined dense height="48" :rules="emptyAddress ? [] : rules.not_empty" hide-details="auto")
            div.text-sm.font-semibold.neutral500--text.mt-4 {{$t('address_2.label')}}
            v-text-field.text-sm.mt-2.round-xl(v-model="billingInfo.address.address_2" :placeholder="$t('address_2.placeholder')" outlined dense height="48" hide-details="auto")
            div.text-sm.font-semibold.neutral500--text.mt-4 {{$t('postcode.label')}}
            v-text-field.text-sm.mt-2.round-xl(v-model="billingInfo.address.postcode" :placeholder="$t('postcode.placeholder')" outlined dense height="48" :rules="emptyAddress ? [] : rules.not_empty" hide-details="auto" @keyup="fetchPostcodes(billingInfo.address.postcode)")
            div.text-sm.font-semibold.neutral500--text.mt-4 {{$t('city.label')}}
            v-text-field.text-sm.mt-2.round-xl(v-model="billingInfo.address.city" :placeholder="$t('city.placeholder')" outlined dense height="48" :rules="emptyAddress ? [] : rules.not_empty" hide-details="auto" :loading="isFetchingAddress")
            div.text-sm.font-semibold.neutral500--text.mt-4 {{$t('state.label')}}
            v-text-field.text-sm.mt-2.round-xl(v-model="billingInfo.address.state" :placeholder="$t('state.placeholder')" outlined dense height="48" :rules="emptyAddress ? [] : rules.not_empty" hide-details="auto" :loading="isFetchingAddress")
            div.text-sm.font-semibold.neutral500--text.mt-4 {{$t('country.label')}}
            v-text-field.text-sm.mt-2.round-xl(v-model="billingInfo.address.country" :placeholder="$t('country.placeholder')" outlined dense height="48" :rules="emptyAddress ? [] : rules.not_empty" hide-details="auto" :loading="isFetchingAddress")
          //- Relationship
          .text-sm.font-semibold.neutral500--text.mt-5 Who is this person to {{ parentPatient.name }}?
          .text-xs.font-regular.neutral500--text.mb-2 For panel claiming purpose only
          v-autocomplete.round-xl(v-model="billingInfo.relationship" :items="relationshipOptions.data" :loading="relationshipOptions.isFetching" :disabled="relationshipOptions.isFetching || relationshipOptions.isError" item-text="name" item-value="id" placeholder="Select relationship" outlined dense height="48" hide-details="auto" return-object)
            template(#append)
              v-icon.icon-height(size="20") $yzi-chevron-down
          //- Staff ID
          div.text-sm.font-semibold.neutral500--text.mt-4(v-if="showStaffId") {{ $t('panel.staff_id_field') }}
          v-text-field.text-sm.mt-2.round-xl(v-if="showStaffId" v-model="billingInfo.staff_id" :placeholder="$t('panel.enter_staff_id')" outlined dense height="48" hide-details="auto")
    v-divider
    v-card-actions.px-6
      v-btn.button-md.neutral700--text.px-0.underline(text @click="closeDialog") {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(:loading="isLoading" color="primary" depressed @click="onSave") {{ $t('save') }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PhoneInput from '@/components/clinic/custom/PhoneInput.vue'
import PatientDropdown from '@/components/clinic/relationship/PatientDropdown.vue'

export default {
  components: {
    PhoneInput, PatientDropdown
  },
  props: {
    open: {
      type: Boolean,
    },
    parentBillingInfo: {
      type: Object,
      default: null
    },
    parentPatient: {
      type: Object,
      required: true
    },
    saveToApi: {
      type: Boolean,
      default: true
    },
    showStaffId: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      billingInfo: {
        name: null,
        phone: null,
        address: {},
        relationship: null,
        staff_id: null
      },
      isLoading: false,
      isFetchingAddress: false,
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required'],
      },
      searchPatient: null,
      relationshipOptions: {
        isFetching: true,
        isError: false,
        data: [],
      },
      phoneKey: 0,
      selfRelationship: {
        id: 'self',
        name: 'Self'
      }
    }
  },
  mounted () {
    this.fetchRelationshipOptions()
    if (this.parentBillingInfo) {
      this.mapData()
    }
  },
  watch: {
    searchPatient(newValue) {
      if (newValue) {
        this.$set(this.billingInfo, 'name', newValue.name)
        this.$set(this.billingInfo, 'phone', newValue.phone)
        this.phoneKey++
        if (newValue.address) {
          const _newAddress = { ...newValue.address }
          this.$set(this.billingInfo, 'address', { ..._newAddress })
        } else {
          this.$set(this.billingInfo, 'address', {})
        }
        this.$set(this.billingInfo, 'relationship', this.getRelationship(newValue))
        this.$set(this.billingInfo, 'ic', newValue.ic)

        // Auto-fill staff_id when patient is selected
        if (newValue.panels?.length > 0) {
          this.$set(this.billingInfo, 'staff_id', newValue.panels[0].staff_id)
        } else {
          this.$set(this.billingInfo, 'staff_id', null)
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      isHq: 'hq/getIsHq',
      registration: 'treatment/getRegistration',
      treatmentLeadPid: 'treatment/getLeadPid'
    }),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    leadPid() {
      return this.$route.params.pid || this.treatmentLeadPid
    },
    emptyAddress() {
      if (Object.keys(this.billingInfo.address).length === 0) {
        return true
      } else if (Object.values(this.billingInfo.address).every(val => !val)) {
        return true
      }
      return false
    },
    payload() {
      const _billingInfo = { 
        name: this.billingInfo.name,
        phone: this.billingInfo.phone,
        extra_data: {
          ...this.billingInfo?.address?.extra_data,
          relationship: { ...this.billingInfo.relationship, ic: this.billingInfo.ic },
        }
      }
      const _address = { ...this.billingInfo.address }
      return { ..._address, ..._billingInfo }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    closeDialog() {
      this.$emit('cancel')
      this.showDialog = false
    },
    mapData () {
      this.billingInfo.name = this.parentBillingInfo.name
      this.billingInfo.phone = this.parentBillingInfo.phone
      if (this.parentBillingInfo.postcode) {
        this.billingInfo.address = {
          address_1: this.parentBillingInfo.address_1,
          address_2: this.parentBillingInfo.address_2,
          city: this.parentBillingInfo.city,
          postcode: this.parentBillingInfo.postcode,
          state: this.parentBillingInfo.state,
          country: this.parentBillingInfo.country
        }
      }
      this.billingInfo.relationship = this.parentBillingInfo.extra_data?.relationship
      this.billingInfo.ic = this.parentBillingInfo.extra_data?.relationship?.ic

      // Auto-fill staff_id from existing registration default_payment
      this.billingInfo.staff_id = this.registration?.default_payment?.staff_id || null
    },
    fetchPostcodes (val) {
      if (!val) {
        return
      }
      if (val.length !== 5) {
        return
      }
      this.isFetchingAddress = true
      this.$axios.get(`/shipping/postcodes?postcode=${this.billingInfo.address.postcode}`).then((response) => {
        const addresses = response.data
        if (addresses.length > 0 && addresses[0].postcode) {
          this.$set(this.billingInfo.address, 'city', addresses[0].city)
          this.$set(this.billingInfo.address, 'state', addresses[0].state)
          this.$set(this.billingInfo.address, 'country', addresses[0].country)
        }
      })
      .catch(() => {
      })
      .finally(() => {
        this.isFetchingAddress = false
      })
    },
    async fetchRelationshipOptions () {
      try {
        this.relationshipOptions.isFetching = true
        const { data } = await this.$axios.get('/clinics/relationship_options')
        this.relationshipOptions.data = data.results
        this.relationshipOptions.data.unshift(this.selfRelationship)
      } catch (error) {
        this.relationshipOptions.isError = true
      } finally {
        this.relationshipOptions.isFetching = false
      }
    },
    async onSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      if (!this.saveToApi) {
        this.$emit('updated', this.payload)
        this.showDialog = false
        return
      }
      try {
        this.isLoading = true

        // Update billing address via invoice endpoint (existing behavior)
        const endpoint = `/invoices/${this.leadPid}`
        const payload = { billing_address: this.payload }
        const { data } = await this.$axios.patch(endpoint, payload)

        // Additionally update staff_id via registration endpoint if staff_id exists
        if (this.billingInfo.staff_id) {
          const registrationEndpoint = `/clinics/${this.company.slug}/registrations/${this.leadPid}`
          const registrationPayload = {
            default_payment: {
              ...this.registration?.default_payment,
              panel: this.registration?.default_payment?.panel?.id || null,
              staff_id: this.billingInfo.staff_id
            }
          }
          await this.$axios.patch(registrationEndpoint, registrationPayload)
        }

        this.$emit('updated')
        this.showMessage(['success', this.$t('success_message.successfully_updated')])
        this.showDialog = false
        this.updateActivityLog(endpoint, payload, data, 'PATCH', this.parentBillingInfo?.id)
      } catch (error) {
        console.error({error});
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isLoading = false
      }
    },
    getRelationship (patient) {
      if (patient.id === this.parentPatient.id) {
        return this.selfRelationship
      }
      let _relationship
      if (patient.relationships && patient.relationships.length > 0) {
        _relationship = patient.relationships.find(relationship => relationship.related_person === this.parentPatient.id)
      }
      if (_relationship) {
        return _relationship.relationship
      } else {
        return null
      }
    },
    updateActivityLog (endpoint, payload, response, method, id) {
      const objId = id || response.billing_address?.id
      const data = {
        company: this.company.id,
        object_id: objId || null,
        object_ref: 'billing_info',
        activity: `Update billing info (lead pid: ${this.leadPid})`,
        raw_data: { endpoint, payload, response, method}
      }
      this.$axios.post('/users/logs', data).catch(() => {})
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  }
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
  .combostyle .v-input__icon {
    min-width: 22px;
    width: 22px;
    margin-top: 4px;
  }
}
.icon-height {
  margin-top: 6px
}
</style>

<i18n>
{
  "en": {
    "address_1": {
      "label": "Address Line 1",
      "placeholder": "e.g. K-3-01, Conezion, Persiaran IRC3"
    },
    "address_2": {
      "label": "Address Line 2",
      "placeholder": "e.g. IOI Resort City"
    },
    "postcode": {
      "label": "Postcode",
      "placeholder": "e.g. 62502"
    },
    "city": {
      "label": "City",
      "placeholder": "e.g. Putrajaya"
    },
    "state": {
      "label": "State",
      "placeholder": "e.g. Wilayah Persekutuan Putrajaya"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Malaysia"
    }
  },
  "id": {
   "address_1": {
      "label": "Nama Jalan, Gedung, No Rumah, RT/RW, Kelurahan",
      "placeholder": "e.g. Jalan Prof. Joko Sutono Sh No.999, RT.14/RW.6, Petogogan, "
    },
    "address_2": {
      "label": "Kecamatan",
      "placeholder": "Kec. Kby. Baru"
    },
    "postcode": {
      "label": "Kode Pos",
      "placeholder": "12160"
    },
    "city": {
      "label": "Kota",
      "placeholder": "Kota Jakarta Selatan"
    },
    "state": {
      "label": "Provinsi",
      "placeholder": "DKI Jakarta"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Indonesia"
    }
  }
}
</i18n>